import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CompleteRegular from './complete-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CompleteRegular {...validProps} />;
}
SvgComponent.iconName = 'completeRegular';

export const CompleteRegularIcon = svgIconWrapper(SvgComponent);
